// extracted by mini-css-extract-plugin
export var markdown = "_v6-0";
export var tableWrapper = "_v6-1";